import React from "react";
import { NavLink } from "react-router-dom";
import { ActivityIcon, ItemIcon } from "../icon/IconTheme";
const ItemsActivityButtons = ({ mainSize }) => {
	return (
		<>
			<div
				className={`item-activity-btn-grp ${mainSize ? "md-resize" : ""}`}
			>
				<NavLink to="/">
					<ItemIcon /> Items
				</NavLink>
				<NavLink to="/activity">
					<ActivityIcon /> Activity
				</NavLink>
			</div>
		</>
	);
};

export default ItemsActivityButtons;
